import _sliced_to_array from "@swc/helpers/src/_sliced_to_array.mjs";
import { createFormContext } from "@coveord/plasma-mantine";
var ref = _sliced_to_array(createFormContext(), 3);
export var FrequencyFormProvider = ref[0], useFrequencyForm = ref[1], useForm = ref[2];

//# sourceMappingURL=FrequencyContext.js.map